import React from 'react';
import { Grid, Typography, FormGroup, FormControlLabel, Switch, Box, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import useCache from '../../app/useCache';
import { CachedEntity } from '../../app/cacheSlice';
import { useCurrentUser } from '../../app/useCurrentUser';

interface BulkImportApplicationsPanelProps {
    clientIds: number[];
    onChange: (ids: number[]) => void;
}

const BulkImportApplicationsPanel: React.FC<BulkImportApplicationsPanelProps> = ({ clientIds, onChange }) => {
    const applications = useCache(CachedEntity.Application);
    const [isAdmin] = useCurrentUser();

    const handleToggle = (clientId: number, enabled: boolean) => {
        if (enabled) {
            onChange([...clientIds, clientId]);
        } else {
            onChange(clientIds.filter(id => id !== clientId));
        }
    };

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                        Select applications to enable for all imported users.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {applications.length === 0 && (
                        <Typography variant="body2" color="text.secondary">
                            No applications available.
                        </Typography>
                    )}
                    <FormGroup>
                        {applications.map((application) => (
                            <FormControlLabel
                                key={`applications.${application.id}`}
                                control={
                                    <Switch
                                        checked={clientIds.includes(application.id)}
                                        onChange={(_, checked) => handleToggle(application.id, checked)}
                                        disabled={!isAdmin}
                                    />
                                }
                                label={
                                    <Box display="flex" alignItems="center">
                                        {application.label ? application.label : application.key}
                                        <Tooltip title={application.description} placement="right">
                                            <InfoIcon color="inherit" fontSize="small" sx={{ ml: 0.5 }} />
                                        </Tooltip>
                                    </Box>
                                }
                            />
                        ))}
                    </FormGroup>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default BulkImportApplicationsPanel;
